/**
 * API client for client detail endpoints
 */

import { apiClient } from './client';

export interface ChannelIdentity {
  channel: string;
  channel_user_id: string;
  channel_username: string | null;
  created_at: string;
}

export interface ClientOrder {
  id: string;
  status: string;
  product_id: string | null;
  total_amount: number | null;
  created_at: string;
  updated_at: string;
}

export interface ClientConversation {
  id: string;
  channel: string;
  order_id: string | null;
  status: string;
  last_message_at: string | null;
  created_at: string;
}

export interface ClientDetail {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  created_at: string;
  metadata: Record<string, any> | null;
  channel_identities: ChannelIdentity[];
  orders: ClientOrder[];
  conversations: ClientConversation[];
  stats: {
    total_orders: number;
    active_conversations: number;
    channels: string[];
  };
}

export const clientsApi = {
  /**
   * Get client detail
   */
  async getDetail(clientId: string): Promise<ClientDetail> {
    const response = await apiClient.get(`/admin/clients/${clientId}`);
    return response.data;
  },
};
